import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import AccountStatusGate from "@/components/AccountStatusGate";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/pages/AuthCallback";
import HomePage from "@/pages/HomePage";
import Dashboard from "@/pages/Dashboard";
import Programs from "@/pages/Programs";
import ProgramDetail from "@/pages/ProgramDetail";
import SessionPlayer from "@/pages/SessionPlayer";
import CognitiveProfile from "@/pages/CognitiveProfile";
import Marketplace from "@/pages/Marketplace";
import CreatorDashboard from "@/pages/CreatorDashboard";
import OrgDashboard from "@/pages/OrgDashboard";
import PricingPage from "@/pages/PricingPage";
import AdminDashboard from "@/pages/AdminDashboard";
import BrainMapProfile from "@/pages/BrainMapProfile";
import ParentDashboard from "@/pages/ParentDashboard";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import CompleteProfile from "@/pages/CompleteProfile";
import PendingApproval from "@/pages/PendingApproval";
import ParentConsentDecide from "@/pages/ParentConsentDecide";
import AccountSettings from "@/pages/AccountSettings";
import InvestorPitch from "@/pages/InvestorPitch";
import CognoGuruLanding from "@/pages/CognoGuruLanding";
import CognoGuruChat from "@/pages/CognoGuruChat";
import TesterGuide from "@/pages/TesterGuide";

function AppRouter() {
  const location = useLocation();

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  const isHome = location.pathname === '/';

  return (
    <>
      <Navbar />
      <AccountStatusGate>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/programs/:id" element={<ProgramDetail />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/parent-consent/:token" element={<ParentConsentDecide />} />
          <Route path="/investors" element={<InvestorPitch />} />
          <Route path="/cognoguru" element={<CognoGuruLanding />} />
          <Route
            path="/cognoguru/:guruId"
            element={
              <ProtectedRoute>
                <CognoGuruChat />
              </ProtectedRoute>
            }
          />
          <Route path="/tester-guide" element={<TesterGuide />} />
          <Route
            path="/complete-profile"
            element={
              <ProtectedRoute>
                <CompleteProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pending-approval"
            element={
              <ProtectedRoute>
                <PendingApproval />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <AccountSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/session/:sessionId"
            element={
              <ProtectedRoute>
                <SessionPlayer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <CognitiveProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/creator"
            element={
              <ProtectedRoute>
                <CreatorDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/org"
            element={
              <ProtectedRoute>
                <OrgDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/brainmap"
            element={
              <ProtectedRoute>
                <BrainMapProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/parent"
            element={
              <ProtectedRoute>
                <ParentDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AccountStatusGate>
      {!isHome && <Footer />}
      <CookieBanner />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
